// AdminTab.js
import React, { useState, useEffect } from 'react'
import {
  KRITERIA, STATUS_PENGAJUAN, STATUS_PENETAPAN,
  statusTagClass, fmtDate, KDEKS_WILAYAH, TIPE_KAWASAN, BASIS
} from './khasConstants'
import { pengajuanApi, penetapanApi, usersApi } from './khasApi'
import { ROLE_LABEL, canAccess } from './khasAuth'
import KhasSearchInput from './KhasSearchInput'

export const LS_DIREKTORI = 'zonakhas_direktori_v1'

/* ── Dokumen Penetapan ───────────────────────────────────── */
function DokumenPenetapan({ id }) {
  const [dokumen, setDokumen] = useState([])

  useEffect(() => {
    penetapanApi.getById(id)
      .then(data => setDokumen(data.dokumen || []))
      .catch(err => console.error(err))
  }, [id])

  if (!dokumen.length) return null

  const BASE = process.env.REACT_APP_KHAS_API_URL || 'http://localhost:4001'

  return (
    <div style={{ marginTop:14, borderTop:'1px solid var(--khas-border)', paddingTop:14 }}>
      <div className="khas-lt" style={{ fontWeight:700, marginBottom:10 }}>Dokumen</div>
      {dokumen.map((d, i) => (
        <a key={i}
          href={`${BASE}/${d.path}`}
          target="_blank" rel="noreferrer"
          style={{
            display:'flex', alignItems:'center', gap:8,
            padding:'8px 12px', borderRadius:8,
            background:'var(--khas-surface-low)', marginBottom:6,
            textDecoration:'none', color:'var(--khas-ink)', fontSize:13,
          }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          <span style={{ flex:1 }}>{d.original_name}</span>
          <span style={{ fontSize:11, color:'var(--khas-muted)', flexShrink:0 }}>
            {d.jenis === 'surat_rekomendasi' ? 'Surat Rekomendasi' : 'Dokumen Penetapan'}
          </span>
        </a>
      ))}
    </div>
  )
}

function AdminTab({ session, submissions, saveSubmissions, onToast, onConfirm }) {
  const [dashTab,           setDashTab]          = useState('pengajuan')
  const [searchPengajuan,   setSearchPengajuan]  = useState('')
  const [filterWilayah,     setFilterWilayah]    = useState('')
  const [filterTipe,        setFilterTipe]       = useState('')
  const [filterStatus,      setFilterStatus]     = useState('')
  const [searchPenetapan,   setSearchPenetapan]  = useState('')
  const [filterPtWilayah,   setFilterPtWilayah]  = useState('')
  const [filterPtStatus,    setFilterPtStatus]   = useState('')
  const [laporanSearch,     setLaporanSearch]    = useState('')
  const [searchUser,        setSearchUser]       = useState('')
  const [selectedSub,       setSelectedSub]      = useState(null)
  const [editSub,           setEditSub]          = useState(false)
  const [editSubForm,       setEditSubForm]      = useState({})
  const [showTolakModal,    setShowTolakModal]   = useState(false)
  const [tolakTarget,       setTolakTarget]      = useState(null)
  const [alasanTolak,       setAlasanTolak]      = useState('')
  const [penetapanList,     setPenetapanList]    = useState([])
  const [selectedPenetapan, setSelectedPenetapan] = useState(null)
  const [editPt,            setEditPt]           = useState(false)
  const [editPtForm,        setEditPtForm]       = useState({})
  const [showKirimSurat,    setShowKirimSurat]   = useState(false)
  const [suratFile,         setSuratFile]        = useState(null)
  const [suratSubjek,       setSuratSubjek]      = useState('')
  const [suratBody,         setSuratBody]        = useState('')
  const [users,             setUsers]            = useState([])
  const [showAddForm,       setShowAddForm]      = useState(false)
  const [userForm,          setUserForm]         = useState({
    nama:'', username:'', password:'', email:'',
    role:'kdeks', kdeks_wilayah:'', instansi_pemda:''
  })
  const [userError,         setUserError]        = useState('')
  const [resetTarget,       setResetTarget]      = useState(null)

  useEffect(() => { loadPenetapan(); loadUsers() }, [])

  const loadPenetapan = async () => {
    try {
      const data = await penetapanApi.getAll()
      setPenetapanList(data.penetapan || [])
    } catch (err) { console.error(err) }
  }

  const loadUsers = async () => {
    try {
      const data = await usersApi.getAll()
      setUsers(data.users || [])
    } catch (err) { console.error(err) }
  }

  const totalPenetapan = penetapanList.length
  const totalTinjauan  = submissions.filter(s => s.status === STATUS_PENGAJUAN.PROSES).length
  const totalSurat     = penetapanList.filter(p => p.status === STATUS_PENETAPAN.SELESAI).length

  const filtered = submissions.filter(s => {
    if (filterWilayah && s.kdeks_wilayah !== filterWilayah) return false
    if (filterTipe    && s.tipe          !== filterTipe)    return false
    if (filterStatus  && s.status        !== filterStatus)  return false
    if (searchPengajuan) {
      const q = searchPengajuan.toLowerCase()
      return s.nama?.toLowerCase().includes(q) || s.id?.toLowerCase().includes(q) ||
             s.pic?.toLowerCase().includes(q)  || s.kota?.toLowerCase().includes(q)
    }
    return true
  })

  const filteredPt = penetapanList.filter(p => {
    if (filterPtWilayah && p.kdeks_wilayah !== filterPtWilayah) return false
    if (filterPtStatus  && p.status        !== filterPtStatus)  return false
    if (searchPenetapan) {
      const q = searchPenetapan.toLowerCase()
      return p.nama?.toLowerCase().includes(q) || p.id?.toLowerCase().includes(q) ||
             p.ditetapkan_oleh?.toLowerCase().includes(q)
    }
    return true
  })

  const filteredLaporan = submissions.filter(s => {
    if (!laporanSearch) return true
    const q = laporanSearch.toLowerCase()
    return s.nama?.toLowerCase().includes(q) ||
           s.kota?.toLowerCase().includes(q) ||
           s.provinsi?.toLowerCase().includes(q)
  })

  const filteredUsers = users.filter(u => {
    if (!searchUser) return true
    const q = searchUser.toLowerCase()
    return u.nama?.toLowerCase().includes(q) ||
           u.username?.toLowerCase().includes(q)
  })

  const setujuiPengajuan = async id => {
    try {
      await pengajuanApi.updateStatus(id, { status: STATUS_PENGAJUAN.DISETUJUI })
      await saveSubmissions()
      setSelectedSub(p => p ? { ...p, status: STATUS_PENGAJUAN.DISETUJUI } : p)
      onToast('Pengajuan disetujui')
    } catch (err) { onToast(err.message) }
  }

  const konfirmasiTolak = (type, id) => {
    setTolakTarget({ type, id }); setAlasanTolak(''); setShowTolakModal(true)
  }

  const submitTolak = async () => {
    if (!alasanTolak.trim()) { onToast('Isi alasan penolakan'); return }
    try {
      if (tolakTarget.type === 'pengajuan') {
        await pengajuanApi.updateStatus(tolakTarget.id, { status: STATUS_PENGAJUAN.DITOLAK, catatan: alasanTolak })
        await saveSubmissions()
        setSelectedSub(p => p ? { ...p, status: STATUS_PENGAJUAN.DITOLAK } : p)
        onToast('Pengajuan ditolak')
      } else {
        await penetapanApi.updateStatus(tolakTarget.id, { status: STATUS_PENETAPAN.DITOLAK, alasan_tolak: alasanTolak })
        await loadPenetapan()
        setSelectedPenetapan(p => p ? { ...p, status: STATUS_PENETAPAN.DITOLAK } : p)
        onToast('Penetapan ditolak')
      }
      setShowTolakModal(false); setTolakTarget(null); setAlasanTolak('')
    } catch (err) { onToast(err.message) }
  }

  const deleteSub = id => onConfirm({
    title: 'Hapus Pengajuan', danger: true, yes: 'Ya, hapus',
    message: 'Hapus pengajuan ini secara permanen?',
    onYes: async () => {
      try {
        await pengajuanApi.delete(id)
        await saveSubmissions()
        setSelectedSub(null)
        onToast('Dihapus')
      } catch (err) { onToast(err.message) }
    }
  })

  const saveEditSub = async () => {
    try {
      await pengajuanApi.update(editSubForm.id, editSubForm)
      await saveSubmissions()
      setSelectedSub({ ...editSubForm })
      setEditSub(false)
      onToast('Pengajuan berhasil diperbarui')
    } catch (err) { onToast(err.message) }
  }

  const setujuiPenetapan = async id => {
    try {
      await penetapanApi.updateStatus(id, { status: STATUS_PENETAPAN.DISETUJUI })
      await loadPenetapan()
      setSelectedPenetapan(p => p ? { ...p, status: STATUS_PENETAPAN.DISETUJUI } : p)
      onToast('Penetapan disetujui')
    } catch (err) { onToast(err.message) }
  }

  const saveEditPt = async () => {
    try {
      await penetapanApi.update(editPtForm.id, editPtForm)
      await loadPenetapan()
      setSelectedPenetapan({ ...editPtForm })
      setEditPt(false)
      onToast('Data penetapan berhasil diperbarui')
    } catch (err) { onToast(err.message) }
  }

  const handleKirimSurat = async () => {
    if (!suratFile)          { onToast('File surat rekomendasi wajib dilampirkan'); return }
    if (!suratSubjek.trim()) { onToast('Subjek wajib diisi'); return }
    try {
      const formData = new FormData()
      formData.append('surat',  suratFile)
      formData.append('subjek', suratSubjek)
      formData.append('body',   suratBody)
      await penetapanApi.kirimSurat(selectedPenetapan.id, formData)
      await loadPenetapan()
      setSelectedPenetapan(p => p ? { ...p, status: STATUS_PENETAPAN.SELESAI } : p)
      setShowKirimSurat(false)
      setSuratFile(null); setSuratSubjek(''); setSuratBody('')
      onToast('Surat Rekomendasi berhasil dikirim')
    } catch (err) { onToast(err.message) }
  }

  const handleAddUser = async e => {
    e.preventDefault(); setUserError('')
    if (!userForm.nama || !userForm.username || !userForm.password) {
      setUserError('Semua field wajib diisi'); return
    }
    try {
      await usersApi.create(userForm)
      await loadUsers()
      setUserForm({ nama:'', username:'', password:'', email:'', role:'kdeks', kdeks_wilayah:'', instansi_pemda:'' })
      setShowAddForm(false)
      onToast('Pengguna ditambahkan')
    } catch (err) { setUserError(err.message) }
  }

  const handleDeleteUser = user => onConfirm({
    title: 'Hapus Pengguna', danger: true, yes: 'Ya, hapus',
    message: `Hapus pengguna <b>${user.nama}</b>?`,
    onYes: async () => {
      try {
        await usersApi.delete(user.id)
        await loadUsers()
        onToast('Dihapus')
      } catch (err) { onToast(err.message) }
    }
  })

  const handleResetPassword = async () => {
    if (!resetTarget?.newPass || resetTarget.newPass.length < 6) { onToast('Min. 6 karakter'); return }
    try {
      await usersApi.resetPassword(resetTarget.user.id, { password_baru: resetTarget.newPass })
      await loadUsers()
      setResetTarget(null)
      onToast('Kata sandi direset')
    } catch (err) { onToast(err.message) }
  }

  function exportExcel() {
    const headers = ['No','Kode','Kawasan','Kota','Provinsi','KDEKS','Tipe','Status Pengajuan','Status Penetapan','Tanggal']
    const rows = filteredLaporan.map((s, i) => {
      const pt = penetapanList.find(p => p.pengajuan_id === s.id)
      return [
        i + 1, s.id, s.nama,
        s.kota          || '—',
        s.provinsi      || '—',
        s.kdeks_wilayah || '—',
        TIPE_KAWASAN.find(t => t.value === s.tipe)?.label || s.tipe,
        s.status,
        pt?.status      || '—',
        fmtDate(s.created_at),
      ].map(cell => `"${String(cell).replace(/"/g, '""')}"`)
    })
    const csv = [
      headers.map(h => `"${h}"`).join(';'),
      ...rows.map(r => r.join(';')),
    ].join('\r\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
    const url  = URL.createObjectURL(blob)
    Object.assign(document.createElement('a'), {
      href: url,
      download: `Laporan-Zona-KHAS-${new Date().toLocaleDateString('id')}.csv`
    }).click()
    URL.revokeObjectURL(url)
    onToast('Laporan diunduh')
  }

  function exportPDF() {
    const rows = filteredLaporan.map((s, i) => {
      const pt = penetapanList.find(p => p.pengajuan_id === s.id)
      return `<tr>
        <td>${i+1}</td><td>${s.nama}</td><td>${s.kota||'—'}, ${s.provinsi||'—'}</td>
        <td>${s.kdeks_wilayah||'—'}</td><td>${s.status}</td>
        <td>${pt?.status||'—'}</td><td>${fmtDate(s.created_at)}</td>
      </tr>`
    }).join('')
    const w = window.open('', '_blank')
    w.document.write(`<!DOCTYPE html><html><head><title>Laporan Zona KHAS</title>
    <style>body{font-family:Arial;padding:20px}table{width:100%;border-collapse:collapse;font-size:12px}
    th,td{border:1px solid #ccc;padding:6px 10px;text-align:left}th{background:#004d27;color:#fff}h2{color:#004d27}</style>
    </head><body>
    <h2>Laporan Zona KHAS KNEKS</h2>
    <p>Dicetak: ${new Date().toLocaleDateString('id',{weekday:'long',day:'2-digit',month:'long',year:'numeric'})}</p>
    <table><thead><tr><th>#</th><th>Kawasan</th><th>Lokasi</th><th>KDEKS</th>
    <th>Status Pengajuan</th><th>Status Penetapan</th><th>Tanggal</th></tr></thead>
    <tbody>${rows}</tbody></table></body></html>`)
    w.document.close(); w.print()
  }

  const setEF = (f, v) => setEditSubForm(p => ({...p, [f]: v}))
  const setPF = (f, v) => setEditPtForm(p => ({...p, [f]: v}))
  const roleOptions = canAccess(session, 'superadmin')
    ? [{v:'kdeks',l:'KDEKS'},{v:'pemda',l:'PEMDA'},{v:'admin',l:'Admin'}]
    : [{v:'kdeks',l:'KDEKS'},{v:'pemda',l:'PEMDA'}]
  const selStyle = { flexShrink:0, width:'auto', height:40 }

  return (
    <div>
      {/* Stats */}
      <div className="khas-stats">
        {[
          [submissions.length, 'Total pengajuan'],
          [totalPenetapan,     'Total penetapan'],
          [totalTinjauan,      'Menunggu tinjauan'],
          [totalSurat,         'Surat Rekomendasi terbit'],
        ].map(([n, l], i) => (
          <div key={i} className="khas-stat">
            <div className="khas-stat-n">{n}</div>
            <div className="khas-stat-l">{l}</div>
          </div>
        ))}
      </div>

      {/* Sub-tab */}
      <div style={{ display:'flex', gap:4, marginBottom:20, flexWrap:'wrap' }}>
        {[
          {id:'pengajuan', label:'Pengajuan Masuk'},
          {id:'penetapan', label:'Penetapan'},
          {id:'pengguna',  label:'Kelola Pengguna'},
          {id:'laporan',   label:'Laporan'},
        ].map(t => (
          <button key={t.id} onClick={() => setDashTab(t.id)}
            className={'khas-btn khas-btn-sm ' + (dashTab === t.id ? 'khas-btn-primary' : 'khas-btn-outline')}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ══ PENGAJUAN ══ */}
      {dashTab === 'pengajuan' && (
        <div className="khas-card">
          <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:14, flexWrap:'nowrap', overflowX:'auto' }}>
            <div style={{ flexShrink:0, flex:1, minWidth:180 }}>
              <KhasSearchInput value={searchPengajuan} onChange={e => setSearchPengajuan(e.target.value)} placeholder="Cari nama kawasan, kode, atau PIC..." />
            </div>
            <select className="khas-input" style={{ ...selStyle, minWidth:160 }} value={filterWilayah} onChange={e => setFilterWilayah(e.target.value)}>
              <option value="">Semua KDEKS</option>
              {KDEKS_WILAYAH.map(w => <option key={w}>{w}</option>)}
            </select>
            <select className="khas-input" style={{ ...selStyle, minWidth:130 }} value={filterTipe} onChange={e => setFilterTipe(e.target.value)}>
              <option value="">Semua tipe</option>
              {TIPE_KAWASAN.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
            <select className="khas-input" style={{ ...selStyle, minWidth:180 }} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
              <option value="">Semua status</option>
              {Object.values(STATUS_PENGAJUAN).map(s => <option key={s}>{s}</option>)}
            </select>
            {(searchPengajuan || filterWilayah || filterTipe || filterStatus) && (
              <button className="khas-btn khas-btn-outline khas-btn-sm" style={{ flexShrink:0 }}
                onClick={() => { setSearchPengajuan(''); setFilterWilayah(''); setFilterTipe(''); setFilterStatus('') }}>
                Reset
              </button>
            )}
          </div>
          <p style={{ fontSize:12.5, color:'var(--khas-muted)', marginBottom:14 }}>
            Menampilkan <b>{filtered.length}</b> dari <b>{submissions.length}</b> pengajuan
          </p>
          {filtered.length === 0 ? (
            <div className="khas-empty">Tidak ada pengajuan yang sesuai filter.</div>
          ) : (
            <div style={{ overflowX:'auto' }}>
              <table className="khas-table">
                <thead>
                  <tr><th>Kode</th><th>Kawasan</th><th>Lokasi</th><th>KDEKS</th><th>Tipe</th><th>Status</th><th>Aksi</th></tr>
                </thead>
                <tbody>
                  {filtered.map(s => (
                    <tr key={s.id}>
                      <td>
                        <code style={{ fontSize:12, background:'var(--khas-bg)', padding:'2px 6px', borderRadius:4 }}>{s.id}</code>
                        <div style={{ fontSize:11, color:'var(--khas-muted)', marginTop:2 }}>{fmtDate(s.created_at)}</div>
                      </td>
                      <td><b>{s.nama}</b><div style={{ fontSize:12, color:'var(--khas-muted)' }}>{s.pic}</div></td>
                      <td style={{ fontSize:13 }}>{s.kota}, {s.provinsi}</td>
                      <td style={{ fontSize:12.5, color:'var(--khas-muted)' }}>{s.kdeks_wilayah||'—'}</td>
                      <td style={{ fontSize:12.5 }}>{TIPE_KAWASAN.find(t=>t.value===s.tipe)?.label||s.tipe}</td>
                      <td><span className={'khas-tag '+statusTagClass(s.status)}>{s.status}</span></td>
                      <td>
                        <button className="khas-btn khas-btn-outline khas-btn-sm"
                          onClick={() => { setSelectedSub(s); setEditSub(false) }}>Tinjau</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══ PENETAPAN ══ */}
      {dashTab === 'penetapan' && (
        <div className="khas-card">
          <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:14, flexWrap:'nowrap', overflowX:'auto' }}>
            <div style={{ flexShrink:0, flex:1, minWidth:180 }}>
              <KhasSearchInput value={searchPenetapan} onChange={e => setSearchPenetapan(e.target.value)} placeholder="Cari nama kawasan atau kode..." />
            </div>
            <select className="khas-input" style={{ ...selStyle, minWidth:160 }} value={filterPtWilayah} onChange={e => setFilterPtWilayah(e.target.value)}>
              <option value="">Semua KDEKS</option>
              {KDEKS_WILAYAH.map(w => <option key={w}>{w}</option>)}
            </select>
            <select className="khas-input" style={{ ...selStyle, minWidth:220 }} value={filterPtStatus} onChange={e => setFilterPtStatus(e.target.value)}>
              <option value="">Semua status</option>
              {Object.values(STATUS_PENETAPAN).map(s => <option key={s}>{s}</option>)}
            </select>
            {(searchPenetapan || filterPtWilayah || filterPtStatus) && (
              <button className="khas-btn khas-btn-outline khas-btn-sm" style={{ flexShrink:0 }}
                onClick={() => { setSearchPenetapan(''); setFilterPtWilayah(''); setFilterPtStatus('') }}>
                Reset
              </button>
            )}
          </div>
          <p style={{ fontSize:12.5, color:'var(--khas-muted)', marginBottom:14 }}>
            Menampilkan <b>{filteredPt.length}</b> dari <b>{penetapanList.length}</b> penetapan
          </p>
          {filteredPt.length === 0 ? (
            <div className="khas-empty">Belum ada penetapan yang sesuai filter.</div>
          ) : (
            <div style={{ overflowX:'auto' }}>
              <table className="khas-table">
                <thead>
                  <tr><th>Kode</th><th>Kawasan</th><th>KDEKS</th><th>Ditetapkan oleh</th><th>Status</th><th>Aksi</th></tr>
                </thead>
                <tbody>
                  {filteredPt.map(p => (
                    <tr key={p.id}>
                      <td>
                        <code style={{ fontSize:12, background:'var(--khas-bg)', padding:'2px 6px', borderRadius:4 }}>{p.id}</code>
                        <div style={{ fontSize:11, color:'var(--khas-muted)', marginTop:2 }}>{fmtDate(p.created_at)}</div>
                      </td>
                      <td><b>{p.nama}</b></td>
                      <td style={{ fontSize:12.5, color:'var(--khas-muted)' }}>{p.kdeks_wilayah||'—'}</td>
                      <td style={{ fontSize:13 }}>{p.ditetapkan_oleh}</td>
                      <td><span className={'khas-tag '+statusTagClass(p.status)}>{p.status}</span></td>
                      <td>
                        <button className="khas-btn khas-btn-outline khas-btn-sm"
                          onClick={() => { setSelectedPenetapan(p); setEditPt(false); setShowKirimSurat(false) }}>
                          Tinjau
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══ KELOLA PENGGUNA ══ */}
      {dashTab === 'pengguna' && (
        <div className="khas-card">
          <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:16 }}>
            <div style={{ flex:1, minWidth:180 }}>
              <KhasSearchInput value={searchUser} onChange={e => setSearchUser(e.target.value)} placeholder="Cari nama atau username..." />
            </div>
            <button className="khas-btn khas-btn-primary khas-btn-sm" style={{ flexShrink:0 }}
              onClick={() => { setShowAddForm(p => !p); setUserError('') }}>
              {showAddForm ? 'Batal' : '+ Tambah Pengguna'}
            </button>
          </div>

          {showAddForm && (
            <div style={{ background:'var(--khas-bg)', border:'1px solid var(--khas-border)', borderRadius:10, padding:'18px 20px', marginBottom:18 }}>
              <div style={{ fontWeight:700, fontSize:14, marginBottom:14, color:'var(--khas-green-d)' }}>Tambah Pengguna Baru</div>
              {userError && <div className="kl-error" style={{ marginBottom:14 }}>{userError}</div>}
              <form onSubmit={handleAddUser}>
                <div className="khas-grid2" style={{ marginBottom:12 }}>
                  <label className="khas-fld" style={{ margin:0 }}>
                    <span className="khas-lt">Nama Lengkap *</span>
                    <input className="khas-input" value={userForm.nama} onChange={e => setUserForm(p => ({...p, nama:e.target.value}))} />
                  </label>
                  <label className="khas-fld" style={{ margin:0 }}>
                    <span className="khas-lt">Username *</span>
                    <input className="khas-input" value={userForm.username} onChange={e => setUserForm(p => ({...p, username:e.target.value}))} autoComplete="off" />
                  </label>
                </div>
                <div className="khas-grid2" style={{ marginBottom:12 }}>
                  <label className="khas-fld" style={{ margin:0 }}>
                    <span className="khas-lt">Email</span>
                    <input className="khas-input" type="email" value={userForm.email} onChange={e => setUserForm(p => ({...p, email:e.target.value}))} />
                  </label>
                  <label className="khas-fld" style={{ margin:0 }}>
                    <span className="khas-lt">Kata Sandi Awal *</span>
                    <input className="khas-input" type="password" value={userForm.password} onChange={e => setUserForm(p => ({...p, password:e.target.value}))} autoComplete="new-password" />
                    <span className="khas-hint">Wajib diganti saat login pertama.</span>
                  </label>
                </div>
                <div className="khas-grid2" style={{ marginBottom:14 }}>
                  <label className="khas-fld" style={{ margin:0 }}>
                    <span className="khas-lt">Role *</span>
                    <select className="khas-input" value={userForm.role}
                      onChange={e => setUserForm(p => ({...p, role:e.target.value, kdeks_wilayah:'', instansi_pemda:''}))}>
                      {roleOptions.map(r => <option key={r.v} value={r.v}>{r.l}</option>)}
                    </select>
                  </label>
                  {(userForm.role === 'kdeks' || userForm.role === 'pemda') && (
                    <label className="khas-fld" style={{ margin:0 }}>
                      <span className="khas-lt">Wilayah KDEKS *</span>
                      <select className="khas-input" value={userForm.kdeks_wilayah} onChange={e => setUserForm(p => ({...p, kdeks_wilayah:e.target.value}))}>
                        <option value="">Pilih wilayah</option>
                        {KDEKS_WILAYAH.map(w => <option key={w}>{w}</option>)}
                      </select>
                    </label>
                  )}
                </div>
                {userForm.role === 'pemda' && (
                  <label className="khas-fld" style={{ marginBottom:14 }}>
                    <span className="khas-lt">Nama Instansi PEMDA *</span>
                    <input className="khas-input" value={userForm.instansi_pemda}
                      onChange={e => setUserForm(p => ({...p, instansi_pemda:e.target.value}))}
                      placeholder="cth. Dinas Ketahanan Pangan Kota Bandung" />
                  </label>
                )}
                <div style={{ display:'flex', gap:10 }}>
                  <button type="submit" className="khas-btn khas-btn-primary khas-btn-sm">Simpan</button>
                  <button type="button" className="khas-btn khas-btn-outline khas-btn-sm"
                    onClick={() => { setShowAddForm(false); setUserError('') }}>Batal</button>
                </div>
              </form>
            </div>
          )}

          <div style={{ overflowX:'auto' }}>
            <table className="khas-table">
              <thead>
                <tr><th>Nama</th><th>Username</th><th>Role</th><th>Wilayah / Instansi</th><th>Terdaftar</th><th>Aksi</th></tr>
              </thead>
              <tbody>
                {filteredUsers.map(u => (
                  <tr key={u.id}>
                    <td>
                      <b>{u.nama}</b>
                      {u.is_first_login && <span className="khas-tag review" style={{ marginLeft:6, fontSize:10 }}>Belum login</span>}
                    </td>
                    <td><code style={{ fontSize:12.5 }}>{u.username}</code></td>
                    <td>
                      <span className={'khas-tag ' + (u.role==='superadmin'?'setuju':u.role==='admin'?'review':u.role==='pemda'?'sk':'baru')}>
                        {ROLE_LABEL(u.role)}
                      </span>
                    </td>
                    <td style={{ fontSize:12.5, color:'var(--khas-muted)' }}>
                      {u.kdeks_wilayah||'—'}
                      {u.instansi_pemda && <div style={{ fontSize:11 }}>{u.instansi_pemda}</div>}
                    </td>
                    <td style={{ fontSize:12.5, color:'var(--khas-muted)' }}>
                      {u.created_at ? new Date(u.created_at).toLocaleDateString('id',{day:'2-digit',month:'short',year:'numeric'}) : '—'}
                    </td>
                    <td>
                      <div style={{ display:'flex', gap:6 }}>
                        <button className="khas-btn khas-btn-outline khas-btn-sm"
                          onClick={() => setResetTarget({user:u, newPass:''})}>Reset Sandi</button>
                        {u.id !== session.id && (
                          <button className="khas-btn khas-btn-danger khas-btn-sm"
                            onClick={() => handleDeleteUser(u)}>Hapus</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ══ LAPORAN ══ */}
      {dashTab === 'laporan' && (
        <div className="khas-card">
          <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:14 }}>
            <div style={{ flex:1 }}>
              <KhasSearchInput value={laporanSearch} onChange={e => setLaporanSearch(e.target.value)} placeholder="Cari nama kawasan, kota, atau provinsi..." />
            </div>
            <button className="khas-btn khas-btn-primary khas-btn-sm" style={{ flexShrink:0 }} onClick={exportExcel}>Ekspor Excel</button>
            <button className="khas-btn khas-btn-outline khas-btn-sm" style={{ flexShrink:0 }} onClick={exportPDF}>Ekspor PDF</button>
          </div>
          <div style={{ overflowX:'auto' }}>
            <table className="khas-table">
              <thead>
                <tr><th>Kode</th><th>Kawasan</th><th>KDEKS</th><th>Tipe</th><th>Status Pengajuan</th><th>Status Penetapan</th><th>Tanggal</th></tr>
              </thead>
              <tbody>
                {filteredLaporan.length === 0 ? (
                  <tr><td colSpan={7} style={{ textAlign:'center', color:'var(--khas-muted)', padding:24 }}>Tidak ada data</td></tr>
                ) : filteredLaporan.map(s => {
                  const pt = penetapanList.find(p => p.pengajuan_id === s.id)
                  return (
                    <tr key={s.id}>
                      <td><code style={{ fontSize:12 }}>{s.id}</code></td>
                      <td><b>{s.nama}</b><div style={{ fontSize:12, color:'var(--khas-muted)' }}>{s.kota}, {s.provinsi}</div></td>
                      <td style={{ fontSize:12.5 }}>{s.kdeks_wilayah||'—'}</td>
                      <td style={{ fontSize:12.5 }}>{TIPE_KAWASAN.find(t=>t.value===s.tipe)?.label||s.tipe}</td>
                      <td><span className={'khas-tag '+statusTagClass(s.status)}>{s.status}</span></td>
                      <td>{pt ? <span className={'khas-tag '+statusTagClass(pt.status)}>{pt.status}</span> : <span style={{ color:'var(--khas-muted-l)', fontSize:12 }}>—</span>}</td>
                      <td style={{ fontSize:12, color:'var(--khas-muted)' }}>{fmtDate(s.created_at)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ══ MODAL: Detail Pengajuan ══ */}
      {selectedSub && (
        <div className="khas-modal show" onClick={e => { if(e.target===e.currentTarget){setSelectedSub(null);setEditSub(false)} }}>
          <div className="khas-modal-box">
            <div className="khas-modal-header">
              <h3>{editSub ? 'Edit Pengajuan' : 'Detail Pengajuan'}</h3>
              <div style={{ display:'flex', gap:8 }}>
                {!editSub && selectedSub.status !== STATUS_PENGAJUAN.DITOLAK && (
                  <button className="khas-btn khas-btn-outline khas-btn-sm"
                    onClick={() => { setEditSubForm({...selectedSub}); setEditSub(true) }}>Edit</button>
                )}
                <button className="khas-modal-close" onClick={() => { setSelectedSub(null); setEditSub(false) }}>×</button>
              </div>
            </div>
            <div className="khas-modal-body">
              {editSub ? (
                <div>
                  <div className="khas-grid2">
                    <label className="khas-fld"><span className="khas-lt">Nama kawasan</span>
                      <input className="khas-input" value={editSubForm.nama||''} onChange={e=>setEF('nama',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Tipe</span>
                      <select className="khas-input" value={editSubForm.tipe||''} onChange={e=>setEF('tipe',e.target.value)}>
                        {TIPE_KAWASAN.map(t=><option key={t.value} value={t.value}>{t.label}</option>)}
                      </select></label>
                    <label className="khas-fld"><span className="khas-lt">Kota</span>
                      <input className="khas-input" value={editSubForm.kota||''} onChange={e=>setEF('kota',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Provinsi</span>
                      <input className="khas-input" value={editSubForm.provinsi||''} onChange={e=>setEF('provinsi',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Pengelola</span>
                      <input className="khas-input" value={editSubForm.pic||''} onChange={e=>setEF('pic',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Telepon</span>
                      <input className="khas-input" value={editSubForm.telp||''} onChange={e=>setEF('telp',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Basis</span>
                      <select className="khas-input" value={editSubForm.basis||''} onChange={e=>setEF('basis',e.target.value)}>
                        <option value="">Pilih basis</option>
                        {BASIS.map(b=><option key={b}>{b}</option>)}
                      </select></label>
                    <label className="khas-fld"><span className="khas-lt">Instansi</span>
                      <input className="khas-input" value={editSubForm.instansi||''} onChange={e=>setEF('instansi',e.target.value)} /></label>
                  </div>
                  <label className="khas-fld"><span className="khas-lt">Catatan</span>
                    <textarea className="khas-input" value={editSubForm.catatan||''} onChange={e=>setEF('catatan',e.target.value)} /></label>
                  <div style={{ display:'flex', gap:10, marginTop:8 }}>
                    <button className="khas-btn khas-btn-primary" onClick={saveEditSub}>Simpan</button>
                    <button className="khas-btn khas-btn-outline" onClick={() => setEditSub(false)}>Batal</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
                    <span className={'khas-tag '+statusTagClass(selectedSub.status)}>{selectedSub.status}</span>
                    <code style={{ fontSize:12, background:'var(--khas-bg)', padding:'2px 8px', borderRadius:4 }}>{selectedSub.id}</code>
                  </div>
                  <dl className="khas-kv">
                    <dt>Kawasan</dt>       <dd>{selectedSub.nama}</dd>
                    <dt>Lokasi</dt>        <dd>{selectedSub.kota}, {selectedSub.provinsi}</dd>
                    <dt>Tipe</dt>          <dd>{TIPE_KAWASAN.find(t=>t.value===selectedSub.tipe)?.label||selectedSub.tipe}</dd>
                    <dt>Basis</dt>         <dd>{selectedSub.basis||'—'}</dd>
                    <dt>Pengelola</dt>     <dd>{selectedSub.pic||'—'} · {selectedSub.telp||'—'}</dd>
                    <dt>Instansi</dt>      <dd>{selectedSub.instansi||'—'}</dd>
                    <dt>KDEKS</dt>         <dd>{selectedSub.kdeks_wilayah||'—'}</dd>
                    <dt>Diajukan oleh</dt> <dd>{selectedSub.submitted_by_nama||'—'}</dd>
                  </dl>
                  <div className="khas-lt" style={{ fontWeight:700, margin:'14px 0 6px' }}>Checklist kriteria</div>
                  <div className="khas-checklist-mini">
                    {KRITERIA.map((c, i) => {
                      const checked = Array.isArray(selectedSub.kriteria) ? selectedSub.kriteria[i] : selectedSub.kriteria?.[i]
                      return (
                        <div key={i} className="khas-check-item">
                          <span className={'khas-ico ' + (checked ? 'y' : 'n')}>{checked ? '✓' : '✕'}</span>
                          <span>{c.t}</span>
                        </div>
                      )
                    })}
                  </div>
                  {selectedSub.status === STATUS_PENGAJUAN.PROSES && (
                    <div style={{ marginTop:18, borderTop:'1px solid var(--khas-border)', paddingTop:16 }}>
                      <div style={{ display:'flex', gap:10 }}>
                        <button className="khas-btn khas-btn-primary" style={{ flex:1 }}
                          onClick={() => setujuiPengajuan(selectedSub.id)}>Setujui</button>
                        <button className="khas-btn khas-btn-danger" style={{ flex:1 }}
                          onClick={() => konfirmasiTolak('pengajuan', selectedSub.id)}>Tolak</button>
                        <button className="khas-btn khas-btn-outline khas-btn-sm"
                          onClick={() => deleteSub(selectedSub.id)}>Hapus</button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL: Detail Penetapan ══ */}
      {selectedPenetapan && (
        <div className="khas-modal show" onClick={e => { if(e.target===e.currentTarget){setSelectedPenetapan(null);setEditPt(false);setShowKirimSurat(false)} }}>
          <div className="khas-modal-box">
            <div className="khas-modal-header">
              <h3>{editPt ? 'Edit Penetapan' : 'Detail Penetapan'}</h3>
              <div style={{ display:'flex', gap:8 }}>
                {!editPt && selectedPenetapan.status !== STATUS_PENETAPAN.SELESAI && (
                  <button className="khas-btn khas-btn-outline khas-btn-sm"
                    onClick={() => { setEditPtForm({...selectedPenetapan}); setEditPt(true) }}>Edit</button>
                )}
                <button className="khas-modal-close" onClick={() => { setSelectedPenetapan(null); setEditPt(false); setShowKirimSurat(false) }}>×</button>
              </div>
            </div>
            <div className="khas-modal-body">
              {editPt ? (
                <div>
                  <div className="khas-grid2">
                    <label className="khas-fld"><span className="khas-lt">Jumlah tenant</span>
                      <input className="khas-input" type="number" value={editPtForm.tenant||0} onChange={e=>setPF('tenant',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Tenant Halal</span>
                      <input className="khas-input" type="number" value={editPtForm.halal||0} onChange={e=>setPF('halal',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Tenant SLHS/IKL</span>
                      <input className="khas-input" type="number" value={editPtForm.sehat||0} onChange={e=>setPF('sehat',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Ditetapkan oleh</span>
                      <input className="khas-input" value={editPtForm.ditetapkan_oleh||''} onChange={e=>setPF('ditetapkan_oleh',e.target.value)} /></label>
                    <label className="khas-fld"><span className="khas-lt">Rencana peresmian</span>
                      <input className="khas-input" type="date" value={editPtForm.rencana_peresmian?.split('T')[0]||''} onChange={e=>setPF('rencana_peresmian',e.target.value)} /></label>
                  </div>
                  <label className="khas-fld"><span className="khas-lt">Catatan</span>
                    <textarea className="khas-input" value={editPtForm.catatan||''} onChange={e=>setPF('catatan',e.target.value)} /></label>
                  <div style={{ display:'flex', gap:10, marginTop:8 }}>
                    <button className="khas-btn khas-btn-primary" onClick={saveEditPt}>Simpan</button>
                    <button className="khas-btn khas-btn-outline" onClick={() => setEditPt(false)}>Batal</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
                    <span className={'khas-tag '+statusTagClass(selectedPenetapan.status)}>{selectedPenetapan.status}</span>
                    <code style={{ fontSize:12, background:'var(--khas-bg)', padding:'2px 8px', borderRadius:4 }}>{selectedPenetapan.id}</code>
                  </div>
                  <dl className="khas-kv">
                    <dt>Kawasan</dt>          <dd>{selectedPenetapan.nama}</dd>
                    <dt>Lokasi</dt>           <dd>{selectedPenetapan.kota}, {selectedPenetapan.provinsi}</dd>
                    <dt>KDEKS</dt>            <dd>{selectedPenetapan.kdeks_wilayah||'—'}</dd>
                    <dt>Jumlah tenant</dt>    <dd>{selectedPenetapan.tenant||'—'}</dd>
                    <dt>Halal</dt>            <dd>{selectedPenetapan.halal||'—'} tenant</dd>
                    <dt>Aman &amp; Sehat</dt> <dd>{selectedPenetapan.sehat||'—'} tenant</dd>
                    <dt>Ditetapkan oleh</dt>  <dd>{selectedPenetapan.ditetapkan_oleh}</dd>
                    <dt>Rencana peresmian</dt>
                    <dd>{selectedPenetapan.rencana_peresmian
                      ? new Date(selectedPenetapan.rencana_peresmian).toLocaleDateString('id',{day:'2-digit',month:'long',year:'numeric'})
                      : '—'}</dd>
                    <dt>Diajukan oleh</dt>    <dd>{selectedPenetapan.submitted_by_nama||'—'}</dd>
                  </dl>

                  {/* ← Dokumen yang diupload user */}
                  <DokumenPenetapan id={selectedPenetapan.id} />

                  {selectedPenetapan.status === STATUS_PENETAPAN.PROSES && !showKirimSurat && (
                    <div style={{ marginTop:18, borderTop:'1px solid var(--khas-border)', paddingTop:16 }}>
                      <div style={{ display:'flex', gap:10 }}>
                        <button className="khas-btn khas-btn-primary" style={{ flex:1 }}
                          onClick={() => setujuiPenetapan(selectedPenetapan.id)}>Setujui</button>
                        <button className="khas-btn khas-btn-danger" style={{ flex:1 }}
                          onClick={() => konfirmasiTolak('penetapan', selectedPenetapan.id)}>Tolak</button>
                      </div>
                    </div>
                  )}

                  {selectedPenetapan.status === STATUS_PENETAPAN.DISETUJUI && !showKirimSurat && (
                    <div style={{ marginTop:18, borderTop:'1px solid var(--khas-border)', paddingTop:16 }}>
                      <div style={{ background:'var(--khas-green-l)', border:'1px solid #a7f3d0', borderRadius:8, padding:'10px 14px', marginBottom:14, fontSize:13.5, color:'var(--khas-green-d)' }}>
                        Penetapan disetujui. Kirimkan Surat Rekomendasi ke KDEKS.
                      </div>
                      <button className="khas-btn khas-btn-primary" onClick={() => setShowKirimSurat(true)}>
                        Kirim Surat Rekomendasi
                      </button>
                    </div>
                  )}

                  {showKirimSurat && (
                    <div style={{ marginTop:18, borderTop:'1px solid var(--khas-border)', paddingTop:16 }}>
                      <div className="khas-lt" style={{ fontWeight:700, marginBottom:14 }}>Kirim Surat Rekomendasi</div>
                      <label className="khas-fld">
                        <span className="khas-lt">Subjek *</span>
                        <input className="khas-input" value={suratSubjek}
                          onChange={e => setSuratSubjek(e.target.value)}
                          placeholder={`Surat Rekomendasi Zona KHAS — ${selectedPenetapan.nama}`} />
                      </label>
                      <label className="khas-fld">
                        <span className="khas-lt">Isi email</span>
                        <textarea className="khas-input" value={suratBody}
                          onChange={e => setSuratBody(e.target.value)}
                          placeholder="Tuliskan isi email yang akan dikirim ke pengaju..."
                          rows={5} style={{ resize:'vertical', minHeight:100 }} />
                      </label>
                      <label className="khas-fld">
                        <span className="khas-lt">Upload Surat Rekomendasi (PDF) *</span>
                        <input className="khas-input" type="file" accept=".pdf"
                          onChange={e => setSuratFile(e.target.files[0]||null)} />
                        <span className="khas-hint" style={{ color:'var(--khas-red)' }}>Wajib dilampirkan.</span>
                        {suratFile && <span className="khas-hint">{suratFile.name}</span>}
                      </label>
                      <div style={{ display:'flex', gap:10, marginTop:8 }}>
                        <button className="khas-btn khas-btn-primary" onClick={handleKirimSurat}>Kirim</button>
                        <button className="khas-btn khas-btn-outline"
                          onClick={() => { setShowKirimSurat(false); setSuratFile(null); setSuratSubjek(''); setSuratBody('') }}>
                          Batal
                        </button>
                      </div>
                    </div>
                  )}

                  {selectedPenetapan.status === STATUS_PENETAPAN.SELESAI && (
                    <div style={{ background:'#d1fae5', border:'1px solid #a7f3d0', borderRadius:8, padding:'10px 14px', marginTop:14, fontSize:13.5, color:'#047857' }}>
                      Surat Rekomendasi telah diterbitkan. Zona siap dipublikasi ke Direktori.
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL: Alasan Tolak ══ */}
      {showTolakModal && (
        <div className="khas-modal show" style={{ zIndex:1100 }} onClick={e => { if(e.target===e.currentTarget) setShowTolakModal(false) }}>
          <div className="khas-modal-box" style={{ maxWidth:440 }}>
            <div className="khas-modal-header">
              <h3>Konfirmasi Penolakan</h3>
              <button className="khas-modal-close" onClick={() => setShowTolakModal(false)}>×</button>
            </div>
            <div className="khas-modal-body">
              <label className="khas-fld">
                <span className="khas-lt">Alasan penolakan *</span>
                <textarea className="khas-input" value={alasanTolak}
                  onChange={e => setAlasanTolak(e.target.value)}
                  placeholder="Tulis alasan penolakan..." autoFocus />
              </label>
              <div style={{ display:'flex', gap:10, marginTop:16 }}>
                <button className="khas-btn khas-btn-danger" style={{ flex:1 }} onClick={submitTolak}>Konfirmasi Tolak</button>
                <button className="khas-btn khas-btn-outline" onClick={() => setShowTolakModal(false)}>Batal</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL: Reset Password ══ */}
      {resetTarget && (
        <div className="khas-modal show" onClick={e => { if(e.target===e.currentTarget) setResetTarget(null) }}>
          <div className="khas-modal-box" style={{ maxWidth:420 }}>
            <div className="khas-modal-header">
              <h3>Reset Kata Sandi</h3>
              <button className="khas-modal-close" onClick={() => setResetTarget(null)}>×</button>
            </div>
            <div className="khas-modal-body">
              <p style={{ fontSize:14, color:'var(--khas-muted)', marginBottom:16 }}>
                Reset untuk <b>{resetTarget.user.nama}</b>
              </p>
              <label className="khas-fld">
                <span className="khas-lt">Kata Sandi Baru</span>
                <input className="khas-input" type="password" value={resetTarget.newPass}
                  onChange={e => setResetTarget(p => ({...p, newPass:e.target.value}))}
                  placeholder="Min. 6 karakter" autoFocus />
              </label>
              <div style={{ display:'flex', gap:10, marginTop:16 }}>
                <button className="khas-btn khas-btn-primary" onClick={handleResetPassword}>Simpan</button>
                <button className="khas-btn khas-btn-outline" onClick={() => setResetTarget(null)}>Batal</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AdminTab